import {
  IssueMcpTokenResponseSchema,
  McpTokenListSchema,
  RevokeMcpTokenResponseSchema,
  type IssueMcpTokenResponse,
  type McpTokenList,
  type RevokeMcpTokenResponse,
} from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export async function listOwnMcpTokens(token: string): Promise<McpTokenList> {
  return McpTokenListSchema.parse(await apiRequest('/me/mcp-tokens', token));
}

export async function issueOwnMcpToken(input: {
  token: string;
  label: string;
  days: number;
}): Promise<IssueMcpTokenResponse> {
  return IssueMcpTokenResponseSchema.parse(await apiRequest('/me/mcp-tokens', input.token, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label: input.label.trim(), days: input.days }),
  }));
}

export async function revokeOwnMcpToken(token: string, tokenId: string): Promise<RevokeMcpTokenResponse> {
  return RevokeMcpTokenResponseSchema.parse(await apiRequest(
    `/me/mcp-tokens/${encodeURIComponent(tokenId)}`,
    token,
    { method: 'DELETE' },
  ));
}
